import React, { useEffect, useState } from 'react';
import { Checkbox, Collapse, Input, InputNumber, Select, Tooltip } from 'antd';
import style from '../index.scss';
import moment from 'moment';
import QueryBuilder from '../QueryBuilder/QueryBuilder';
import { fields, group_by } from '../config.js';
import { connect } from 'react-redux';
import { InfoCircleOutlined, InfoCircleTwoTone } from '@ant-design/icons';

const { Panel } = Collapse;

const getToolTip = (title) => {
  return (
    <div style={{ marginLeft: '10px', marginTop: '-3px' }}>
      <Tooltip title={title}>
        <InfoCircleOutlined twoToneColor="#000" />
      </Tooltip>
    </div>
  );
};
const Functions = ({
  typology,
  variantInfo = null,
  typoIndex,
  variantIndex,
  setVariantRenderData,
  fetchBlackListApi,
  blackList,
  isReadOnly,
  onDirtyField
}) => {
  const selectedRules = JSON.parse(typology.rules).find(
    (v) => v.ruleId === variantInfo.ruleId
  );
  const [matchList, setMatchList] = useState([]);

  useEffect(() => {
    if (blackList && blackList.data && blackList.data.payload) {
      setMatchList(blackList.data.payload);
    }
  }, [blackList]);

  const [functionInfo, setFunctionInfo] = useState(variantInfo);

  const onChangeFunction = (e, funIndex, key) => {
    setFunctionInfo((prev) => {
      prev.function[funIndex][key] = e.target.value;
      if (key === 'functionName' && e.target.value === 'aggregation') {
        prev.function[funIndex].args = {
          lookback: {
            start: 0,
            end: 0
          }
        };
      }
      if (key === 'functionName' && e.target.value === 'screening') {
        prev.function[funIndex].args = {};
      }
      return {
        ...prev
      };
    });
    onDirtyField();
  };

  const onChangeCalendarType = (e, funIndex, key) => {
    setFunctionInfo((prev) => {
      prev.function[funIndex].args[key] = e.target.value;
      return {
        ...prev
      };
    });
    onDirtyField();
  };

  const onChangeSelectType = (val, funIndex, key) => {
    setFunctionInfo((prev) => {
      prev.function[funIndex].args[key] = val;
      if (key === 'field') {
        prev.function[funIndex].args.aggregationFunction = '';
      }
      return {
        ...prev
      };
    });
    onDirtyField();
  };

  const onChangeMatchSelectType = (val, funIndex, key) => {
    setFunctionInfo((prev) => {
      prev.function[funIndex].args[key] = val;
      return {
        ...prev
      };
    });
    onDirtyField();
  };

  const onChangeCalendarLookback = (val, funIndex, key) => {
    setFunctionInfo((prev) => {
      prev.function[funIndex].args = {
        ...prev.function[funIndex].args,
        lookback: val
      };
      return {
        ...prev
      };
    });
  };

  useEffect(() => {
    if (setVariantRenderData) {
      setVariantRenderData((prev) => {
        let dataToSet = prev;
        dataToSet[typoIndex].variants[variantIndex] = functionInfo;
        return [...dataToSet];
      });
    }
  }, [functionInfo]);

  const addNewFunction = () => {
    functionInfo.function.push({
      args: {},
      functionName: 'screening',
      name: 'function1' + functionInfo.function?.length
    });
    setFunctionInfo({
      ...functionInfo
    });
    onDirtyField();
  };

  return (
    <div>
      <Collapse
        accordion
        expandIconPosition={'right'}
        className={style.typologiesCollapse}>
        {functionInfo &&
          functionInfo.function &&
          functionInfo.function?.map((item, index) => (
            <Panel header={<span>{item.name}</span>} key={index}>
              <div className={style.functionbox}>
                <div>
                  <label style={{ display: 'flex' }}>
                    Function Name
                    <span style={{ color: 'red' }}>*</span>
                    {getToolTip(
                      `The function name is a unique identifier given to a particular operation or set of instructions. It enables users to reference and utilize specific functionalities offered.`
                    )}
                  </label>
                  <Input
                    disabled={isReadOnly}
                    value={item.name}
                    onChange={(e) => onChangeFunction(e, index, 'name')}
                  />
                </div>
                <div>
                  <label style={{ display: 'flex' }}>
                    Function Type<span style={{ color: 'red' }}>*</span>
                    {getToolTip(
                      `Categorization of functions based on their behavior or purpose; whether Aggregation or Matching`
                    )}
                  </label>
                  <SegmentButton
                    isReadOnly={isReadOnly}
                    value={item.functionName}
                    index={index}
                    onChangeFunction={onChangeFunction}
                  />
                </div>
              </div>
              {item.functionName === 'aggregation' ? (
                <AggregateypeFunction
                  item={item}
                  variantInfo={variantInfo}
                  typoIndex={typoIndex}
                  isReadOnly={isReadOnly}
                  variantIndex={variantIndex}
                  functionIndex={index}
                  onChangeSelectType={onChangeSelectType}
                  onChangeCalendarType={onChangeCalendarType}
                  onChangeCalendarLookback={onChangeCalendarLookback}
                  setVariantRenderData={setVariantRenderData}
                  onDirtyField={onDirtyField}
                  selectedRules={selectedRules}
                />
              ) : (
                <MatchTypeFunction
                  matchList={matchList}
                  onChangeMatchSelectType={onChangeMatchSelectType}
                  item={item.args || {}}
                  index={index}
                  isReadOnly={isReadOnly}
                  onChangeFunction={onChangeFunction}
                  selectedRules={selectedRules}
                />
              )}
            </Panel>
          ))}
      </Collapse>
      {/* {!isReadOnly && (
        <button className={style.addBtn} onClick={addNewFunction}>
          + Add new Function
        </button>
      )} */}
    </div>
  );
};

const MatchTypeFunction = ({
  item,
  index,
  onChangeFunction,
  onChangeMatchSelectType,
  matchList,
  isReadOnly,
  selectedRules
}) => {
  const [matchField, setMatchField] = useState([]);
  const [matchListArr, setMatchListArr] = useState([...matchList]);
  const [matchMethodArr, setMatchMethodArr] = useState([]);

  useEffect(() => {
    // Match Field
    if (!selectedRules.function[index].args.screeningFieldList) {
      setMatchField(Object.keys(fields).sort());
    } else if (
      selectedRules.function[index].args.screeningFieldList
        ?.toLowerCase()
        .split(',')
        .includes('any')
    ) {
      setMatchField(Object.keys(fields).sort());
    } else if (
      !selectedRules.function[index].args.screeningFieldList
        ?.toLowerCase()
        .split(',')
        .includes('any')
    ) {
      let matchFieldArr = selectedRules.function[index].args.screeningFieldList
        ?.toLowerCase()
        .split(',');
      setMatchField(matchFieldArr);
    }

    // // Match List
    // if (selectedRules.function[index].args?.screeningList?.length === 0) {
    //   setMatchListArr([...matchList])
    // }
    // if (selectedRules.function[index].args.screeningList?.includes('Any')) {
    //   setMatchListArr([...matchList])
    //   onChangeMatchSelectType([], index, 'screeningList');
    // }
    // if (!selectedRules.function[index].args.screeningList?.includes('Any')) {
    //   let matchListArr1 = selectedRules.function[index].args.screeningList?.map(m => {
    //     return {
    //       name: m
    //     }
    //   }) || []
    //   setMatchListArr([...matchListArr1])
    //   if (matchListArr1?.length > 1) {
    //     onChangeMatchSelectType(matchListArr1[0].name, index, 'screeningList');
    //   }
    // }

    // Match Method
    if (!selectedRules.function[index].args.screeningMethodList) {
      setMatchMethodArr([
        {
          label: 'exact_match',
          value: 'exact_match'
        },
        {
          label: 'jaccard_index',
          value: 'jaccard_index'
        }
      ]);
    } else if (
      selectedRules.function[index].args.screeningMethodList
        ?.toLowerCase()
        .split(',')
        .includes('any')
    ) {
      setMatchMethodArr([
        {
          label: 'exact_match',
          value: 'exact_match'
        },
        {
          label: 'jaccard_index',
          value: 'jaccard_index'
        }
      ]);
    } else if (
      !selectedRules.function[index].args.screeningMethodList
        ?.toLowerCase()
        .split(',')
        .includes('any')
    ) {
      const matchMethodArr1 =
        selectedRules.function[index].args.screeningMethodList
          ?.toLowerCase()
          .split(',')
          ?.map((m) => {
            return {
              label: m,
              value: m
            };
          }) || [];
      setMatchMethodArr([...matchMethodArr1]);
    }
  }, []);

  return (
    <div className={style.matchtype}>
      <div className={style.matchmethod}>
        <div className="matchfield">
          <label style={{ display: 'flex' }}>
            Match Field<span style={{ color: 'red' }}>*</span>
            {getToolTip(
              'A matching field refers to a specific attribute used to identify and compare data for matches. It serves as a basis for conducting comparisons between different data sets.'
            )}
          </label>
          <Select
            disabled={isReadOnly}
            value={item.screeningField}
            placeholder="Please Select"
            onChange={(e) =>
              onChangeMatchSelectType(e, index, 'screeningField')
            }>
            {matchField?.map((f) => (
              <Select.Option value={f}>{f}</Select.Option>
            ))}
          </Select>
        </div>
        <div className="matchlist">
          <label style={{ display: 'flex' }}>
            Match List<span style={{ color: 'red' }}>*</span>
            {getToolTip(
              'The list of records against which the selected field would be matched'
            )}
          </label>
          <Select
            mode="multiple"
            disabled={isReadOnly}
            value={item.screeningList}
            placeholder="Please Select"
            onChange={(e) =>
              onChangeMatchSelectType(e, index, 'screeningList')
            }>
            {matchListArr
              .sort((a, b) => a?.name?.localeCompare(b?.name))
              ?.map((f) => (
                <Select.Option value={f.name}>{f.name}</Select.Option>
              ))}
          </Select>
        </div>
      </div>
      <div className={style.matchmethod}>
        <div className="matchlist">
          <label style={{ display: 'flex' }}>
            Method<span style={{ color: 'red' }}>*</span>
            {getToolTip(
              'Fuzzy matching is a technique used to find approximate matches for data that may have variations in spelling, formatting, or other discrepancies. It’s useful for identifying similar or related records even when exact matches are not available.'
            )}
          </label>
          <Select
            disabled={isReadOnly}
            value={item.screeningMethod}
            placeholder="Please Select"
            onChange={(e) =>
              onChangeMatchSelectType(e, index, 'screeningMethod')
            }>
            {matchMethodArr?.map((f) => (
              <Select.Option value={f.value}>{f.label}</Select.Option>
            ))}
          </Select>
        </div>
        <div className="matchlist">
          <label style={{ display: 'flex' }}>
            Fuzzy Factor<span style={{ color: 'red' }}>*</span>
            {getToolTip(
              'The fuzzy factor parameter adjusts the sensitivity of a fuzzy matching process. It allows users to control the level of tolerance for discrepancies when identifying approximate matches between data sets. Expected value is between 0-1.'
            )}
          </label>
          <InputNumber
            disabled={isReadOnly}
            value={item.fuzzinessFactor}
            min={0}
            max={1}
            onChange={(val) =>
              onChangeMatchSelectType(val, index, 'fuzzinessFactor')
            }
          />
        </div>
      </div>
    </div>
  );
};

const AggregateypeFunction = ({
  item,
  typoIndex,
  variantIndex,
  functionIndex,
  variantInfo,
  onChangeCalendarType,
  onChangeSelectType,
  onChangeCalendarLookback,
  setVariantRenderData,
  isReadOnly,
  onDirtyField,
  selectedRules
}) => {
  const [startValue, setStartValue] = useState({ value: 0, type: 'hour' });
  const [endValue, setEndValue] = useState({ value: 0, type: 'hour' });
  const [aggregateField, setAggregateField] = useState([]);
  const [groupByArr, setGroupByArr] = useState([]);

  const getLookBackValue = (loopback = 0, type) => {
    let valueToSave;
    if (loopback === 0) {
      valueToSave = {
        value: 0,
        type: 'second'
      };
    } else {
      const SECONDS_PER_MINUTE = 60;
      const SECONDS_PER_HOUR = 60 * SECONDS_PER_MINUTE;
      const SECONDS_PER_DAY = 24 * SECONDS_PER_HOUR;
      const SECONDS_PER_MONTH = 30 * SECONDS_PER_DAY;
      const SECONDS_PER_YEAR = 365 * SECONDS_PER_MONTH;

      if (loopback % SECONDS_PER_YEAR === 0) {
        valueToSave = {
          value: loopback / SECONDS_PER_YEAR,
          type: 'year'
        };
      } else if (loopback % SECONDS_PER_MONTH === 0) {
        valueToSave = {
          value: loopback / SECONDS_PER_MONTH,
          type: 'month'
        };
      } else if (loopback % SECONDS_PER_DAY === 0) {
        valueToSave = {
          value: loopback / SECONDS_PER_DAY,
          type: 'day'
        };
      } else if (loopback % SECONDS_PER_HOUR === 0) {
        valueToSave = {
          value: loopback / SECONDS_PER_HOUR,
          type: 'hour'
        };
      } else if (loopback % SECONDS_PER_MINUTE === 0) {
        valueToSave = {
          value: loopback / SECONDS_PER_MINUTE,
          type: 'minute'
        };
      } else {
        valueToSave = {
          value: loopback,
          type: 'second'
        };
      }
    }
    if (type === 'start') {
      setStartValue({ ...valueToSave });
    } else {
      setEndValue({ ...valueToSave });
    }
  };
  useEffect(() => {
    getLookBackValue(item.args?.lookback?.start || 0, 'start');
    getLookBackValue(item.args?.lookback?.end || 0, 'end');
    if (!selectedRules.function[functionIndex].args.fieldList) {
      setAggregateField(Object.keys(fields).sort());
    } else if (
      selectedRules.function[functionIndex].args.fieldList
        ?.toString()
        .toLowerCase()
        .split(',')
        .includes('any')
    ) {
      setAggregateField(Object.keys(fields).sort());
    } else if (
      !selectedRules.function[functionIndex].args.fieldList
        ?.toString()
        .toLowerCase()
        .split(',')
        .includes('any')
    ) {
      let aggregateFieldArr =
        selectedRules.function[functionIndex].args.fieldList
          ?.toString()
          ?.toLowerCase()
          ?.split(',') || [];
      setAggregateField([...aggregateFieldArr]);
    }

    if (!selectedRules.function[functionIndex].args.groupingKeysList) {
      setGroupByArr(group_by);
    } else if (
      selectedRules.function[functionIndex].args.groupingKeysList
        ?.toString()
        .toLowerCase()
        .split(',')
        .includes('any')
    ) {
      setGroupByArr(group_by);
    } else if (
      !selectedRules.function[functionIndex].args.groupingKeysList
        ?.toString()
        .toLowerCase()
        .split(',')
        .includes('any')
    ) {
      let aggregateFieldArr =
        selectedRules.function[functionIndex].args.groupingKeysList
          ?.toString()
          .toLowerCase()
          .split(',')
          ?.map((m) => {
            return {
              label: m,
              value: m
            };
          }) || [];
      setGroupByArr([...aggregateFieldArr]);
    }
  }, []);

  const checkDurationAndUpdate = () => {
    const SECONDS_PER_MINUTE = 60;
    const SECONDS_PER_HOUR = 60 * SECONDS_PER_MINUTE;
    const SECONDS_PER_DAY = 24 * SECONDS_PER_HOUR;
    const SECONDS_PER_MONTH = 30 * SECONDS_PER_DAY;
    const SECONDS_PER_YEAR = 365 * SECONDS_PER_MONTH;
    let startMs = 0;
    let endMs = 0;
    if (startValue.type === 'year') {
      startMs = startValue.value * SECONDS_PER_YEAR;
    }
    if (startValue.type === 'month') {
      startMs = startValue.value * SECONDS_PER_MONTH;
    }
    if (startValue.type === 'day') {
      startMs = startValue.value * SECONDS_PER_DAY;
    }
    if (startValue.type === 'hour') {
      startMs = startValue.value * SECONDS_PER_HOUR;
    }
    if (startValue.type === 'minute') {
      startMs = startValue.value * SECONDS_PER_MINUTE;
    }
    if (startValue.type === 'second') {
      startMs = startValue.value;
    }
    if (endValue.type === 'year') {
      endMs = endValue.value * SECONDS_PER_YEAR;
    }
    if (endValue.type === 'month') {
      endMs = endValue.value * SECONDS_PER_MONTH;
    }
    if (endValue.type === 'day') {
      endMs = endValue.value * SECONDS_PER_DAY;
    }
    if (endValue.type === 'hour') {
      endMs = endValue.value * SECONDS_PER_HOUR;
    }
    if (endValue.type === 'minute') {
      endMs = endValue.value * SECONDS_PER_MINUTE;
    }
    if (endValue.type === 'second') {
      endMs = endValue.value;
    }
    onChangeCalendarLookback(
      {
        start: startMs,
        end: endMs
      },
      functionIndex,
      'start'
    );
  };

  useEffect(() => {
    if (startValue.value || endValue.value) {
      checkDurationAndUpdate();
    }
  }, [startValue, endValue]);

  const aggFieldListD = (val) => {
    if (fields[val]?.type === 'number') {
      return [
        {
          value: 'average',
          label: 'Average'
        },
        {
          value: 'collect_set',
          label: 'Collect Set'
        },
        {
          value: 'count',
          label: 'Count'
        },
        {
          value: 'count_distinct',
          label: 'Count Distinct'
        },
        {
          value: 'min',
          label: 'Min'
        },
        {
          value: 'max',
          label: 'Max'
        },
        {
          value: 'sum',
          label: 'Sum'
        }
      ];
    } else if (fields[val]?.type === 'datetime') {
      return [
        {
          value: 'min',
          label: 'Min'
        },
        {
          value: 'max',
          label: 'Max'
        }
      ];
    } else {
      return [
        {
          value: 'collect_set',
          label: 'Collect Set'
        },
        {
          value: 'count',
          label: 'Count'
        },
        {
          value: 'count_distinct',
          label: 'Count Distinct'
        }
      ];
    }
  };

  return (
    <div className={style.aggregatetype}>
      <div className="aggragete--field-row">
        <div className="matchfield">
          <label style={{ display: 'flex' }}>
            Aggregate Field<span style={{ color: 'red' }}>*</span>
            {getToolTip(
              'An aggregate field represents the field on which the aggregation function will be performed to get a single result'
            )}
          </label>
          <Select
            value={item.args.field}
            disabled={isReadOnly}
            placeholder="Please Select"
            onChange={(e) => onChangeSelectType(e, functionIndex, 'field')}>
            {aggregateField?.map((f) => (
              <Select.Option key={f} value={f}>
                {f}
              </Select.Option>
            ))}
          </Select>
        </div>
        <div className="matchfield">
          <label style={{ display: 'flex' }}>
            Aggregate Function<span style={{ color: 'red' }}>*</span>
            {getToolTip(
              'An aggregate function performs a calculation on a set of values and returns a single result.'
            )}
          </label>
          <Select
            value={item.args.aggregationFunction}
            disabled={isReadOnly}
            placeholder="Please Select"
            onChange={(e) =>
              onChangeSelectType(e, functionIndex, 'aggregationFunction')
            }>
            {aggFieldListD(item.args.field)
              .filter(
                (f) =>
                  f.value ===
                  (selectedRules.function[
                    functionIndex
                  ].args?.aggregationFunctionList?.toLowerCase() || f.value)
              )
              ?.map((module, index) => {
                return (
                  <Select.Option
                    key={`module.value-${index}`}
                    value={module.value}>
                    {module.label}
                  </Select.Option>
                );
              })}
          </Select>
        </div>
        <div className="matchfield">
          <label style={{ display: 'flex' }}>
            Group By<span style={{ color: 'red' }}>*</span>
            {getToolTip(
              'The ‘Group By’ clause is used to group rows that have the same values in specified columns. It’s used in conjunction with aggregate functions to arrange data into subsets, making it easier to analyze and summarize information. Ex: Basis sender, receiver, etc'
            )}
          </label>
          <Select
            value={item.args.groupingKeys}
            disabled={isReadOnly}
            mode="multiple"
            placeholder="Please Select"
            onChange={(e) =>
              onChangeSelectType(e, functionIndex, 'groupingKeys')
            }>
            {groupByArr
              ?.sort((a, b) => a.label.localeCompare(b.label))
              ?.map((module) => {
                return (
                  <Select.Option key={module.value} value={module.value}>
                    {module.label}
                  </Select.Option>
                );
              })}
          </Select>
        </div>
      </div>
      <div className={style.aggregatetype}>
        <div>
          <label style={{ display: 'flex' }}>
            Time Table<span style={{ color: 'red' }}>*</span>
            {getToolTip(
              'This is used to select the type of timeframe to be used. Ex: “Calendar” calculates basis each day, “Rolling” calculate from a specific point in time to another and “Global” is lifetime'
            )}
          </label>
          <CalendarTypeButton
            isReadOnly={isReadOnly}
            value={item.args.lookbackType}
            index={functionIndex}
            onChangeCalendarType={onChangeCalendarType}
          />
        </div>
        <label>
          Time Window<span style={{ color: 'red' }}>*</span>
        </label>
        <div className="aggragete--field-row" style={{ marginTop: '-15px' }}>
          <div className="matchfield">
            <label>From</label>
            <div className="multiple-inputs">
              <Input
                disabled={isReadOnly || item.args.lookbackType === 'global'}
                value={startValue.value}
                onChange={(e) => {
                  setStartValue((prev) => ({
                    ...prev,
                    value: e.target.value
                  }));
                  onDirtyField();
                }}
              />
              <Select
                id="start-select"
                value={startValue.type}
                placeholder="Please Select"
                disabled={isReadOnly || item.args.lookbackType === 'global'}
                onChange={(val) => {
                  setStartValue((prev) => ({
                    ...prev,
                    type: val
                  }));
                  onDirtyField();
                }}>
                {[
                  {
                    value: 'day',
                    label: 'Day/s'
                  },
                  {
                    value: 'hour',
                    label: 'Hour/s'
                  },
                  {
                    value: 'minute',
                    label: 'Minute/s'
                  },
                  {
                    value: 'second',
                    label: 'Second/s'
                  },
                  {
                    value: 'month',
                    label: 'Month/s'
                  },
                  {
                    value: 'year',
                    label: 'Year/s'
                  }
                ]?.map((module, index) => {
                  return (
                    <Select.Option key={index} value={module.value}>
                      {module.label}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
          </div>
          <div className="matchlist">
            <label>To</label>
            <div className="multiple-inputs">
              <Input
                disabled={isReadOnly || item.args.lookbackType === 'global'}
                value={endValue.value}
                onChange={(e) => {
                  setEndValue((prev) => ({
                    ...prev,
                    value: e.target.value
                  }));
                  onDirtyField();
                }}
              />
              <Select
                id="end-select"
                value={endValue.type}
                disabled={isReadOnly || item.args.lookbackType === 'global'}
                onChange={(val) => {
                  setEndValue((prev) => ({
                    ...prev,
                    type: val
                  }));
                  onDirtyField();
                }}
                placeholder="Please Select">
                {[
                  {
                    value: 'day',
                    label: 'Day/s'
                  },
                  {
                    value: 'hour',
                    label: 'Hour/s'
                  },
                  {
                    value: 'minute',
                    label: 'Minute/s'
                  },
                  {
                    value: 'second',
                    label: 'Second/s'
                  },
                  {
                    value: 'month',
                    label: 'Month/s'
                  },
                  {
                    value: 'year',
                    label: 'Year/s'
                  }
                ]?.map((module, index) => {
                  return (
                    <Select.Option key={index} value={module.value}>
                      {module.label}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
          </div>
          <div
            className="matchlist"
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
            <Checkbox
              checked={item.args.includeCurrentTransaction}
              onChange={(e) =>
                onChangeSelectType(
                  e.target.checked,
                  functionIndex,
                  'includeCurrentTransaction'
                )
              }>
              {`Include Current`}
            </Checkbox>
            <Tooltip
              title={`Please check the checkbox, in order to include the current transaction while verifying the rule`}>
              <InfoCircleOutlined twoToneColor="#000" />
            </Tooltip>
          </div>
        </div>
      </div>
      <div className={style.aggregatetype}>
        <label>Triggers</label>
        <QueryBuilder
          typoIndex={typoIndex}
          variantInfo={variantInfo}
          variantIndex={variantIndex}
          functionIndex={functionIndex}
          type={`aggregationCondition`}
          isReadOnly={isReadOnly}
          allowNewIfEmpty={true}
          queryValue={item.args.aggregationCondition}
          setVariantRenderData={setVariantRenderData}
          onDirtyField={onDirtyField}
        />
      </div>
    </div>
  );
};

const SegmentButton = ({ value, index, onChangeFunction, isReadOnly }) => {
  return (
    <div className={style.segmentButton}>
      <input
        disabled={isReadOnly}
        type="radio"
        name={`segment-btn-${index}`}
        checked={value.toLowerCase() === 'aggregation'}
        onChange={(e) => onChangeFunction(e, index, 'functionName')}
        value="aggregation"
        id={`aggregation-${index}`}
      />
      <label htmlFor={`aggregation-${index}`}>Aggregate</label>

      <input
        disabled={isReadOnly}
        type="radio"
        name={`segment-btn-${index}`}
        value="screening"
        checked={value.toLowerCase() === 'screening'}
        onChange={(e) => onChangeFunction(e, index, 'functionName')}
        id={`match-${index}`}
      />
      <label htmlFor={`match-${index}`}>Match</label>
    </div>
  );
};

const CalendarTypeButton = ({
  value = '',
  index,
  onChangeCalendarType,
  isReadOnly
}) => {
  return (
    <div className={style.segmentButton}>
      <input
        disabled={isReadOnly}
        type="radio"
        name={`cal-type-btn-${index}`}
        onChange={(e) => onChangeCalendarType(e, index, 'lookbackType')}
        checked={value.toLowerCase() === 'calendar'}
        value="calendar"
        id={`calendar-${index}`}
      />
      <label htmlFor={`calendar-${index}`}>Calendar</label>

      <input
        disabled={isReadOnly}
        type="radio"
        name={`cal-type-btn-${index}`}
        onChange={(e) => onChangeCalendarType(e, index, 'lookbackType')}
        value="continuous"
        checked={value.toLowerCase() === 'continuous'}
        id={`continuous-${index}`}
      />
      <label htmlFor={`continuous-${index}`}>Rolling</label>

      <input
        disabled={isReadOnly}
        type="radio"
        name={`cal-type-btn-${index}`}
        onChange={(e) => onChangeCalendarType(e, index, 'lookbackType')}
        value="global"
        checked={value.toLowerCase() === 'global'}
        id={`global-${index}`}
      />
      <label htmlFor={`global-${index}`}>Lifetime</label>
    </div>
  );
};

function mapStateToProps(state, ownProps = {}) {
  return {
    blackList: state.trmDashboard.blackList
  };
}

export default connect(mapStateToProps, null)(Functions);
